var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spl-login"},[_c('main-header-login'),_c('subheader-login'),_c('recover-password-modal'),_c('message-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }